import React from "react";

function HomeIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
    >
      <g
        id="Group_24031"
        data-name="Group 24031"
        transform="translate(-6623 -1999)"
      >
        <rect
          id="Rectangle_9757"
          data-name="Rectangle 9757"
          width="32"
          height="32"
          transform="translate(6623 1999)"
          fill="var(--primary-black)"
          opacity="0"
        />
        <path
          id="Path_16174"
          data-name="Path 16174"
          d="M15.812,23.7H23.5V12.146L14.53,5.171,5.562,12.146V23.7h7.687V16.018h2.562Zm10.249,1.281a1.281,1.281,0,0,1-1.281,1.281H4.281A1.281,1.281,0,0,1,3,24.986V11.52a1.281,1.281,0,0,1,.495-1.011L13.744,2.537a1.281,1.281,0,0,1,1.573,0l10.249,7.972a1.281,1.281,0,0,1,.495,1.011Z"
          transform="translate(6624 2000.733)"
          fill="var(--primary-black)"
        />
      </g>
    </svg>
  );
}

export default HomeIcon;
